import React, { useState, useEffect, useCallback, useRef } from 'react'
import Router from 'next/router'
import {
  useResponsive,
  IResponsiveType,
  computedResponsive,
} from 'Components/hooks/use-responsive'
import PubSub from 'pubsub-js'
import { sendTeaCommEvent } from 'lib/tea-analyze'

const DEFAULT_TYPE = ''

function HeaderSwitch({ pageType = 'new' }: { pageType?: string }) {
  const isFixType = pageType?.indexOf('no-nav') > -1
  // 手动强制切换
  const [handleType, setHandleType] = useState('')
  const responsive = useResponsive()
  const [responsiveType, setResponsiveType] =
    useState<IResponsiveType>(DEFAULT_TYPE)

  // 是否手动点击触发
  const isHandel = useRef(false)

  useEffect(() => {
    setResponsiveType(computedResponsive(responsive))
    if (isHandel.current) {
      isHandel.current = false
    }
  }, [responsive])

  const handleClick = useCallback(() => {
    if (handleType) {
      // 没有侧边栏 点击 只能浮层
      if (isFixType) {
        PubSub.publish('OPEN_FIX_NAV', true)
        return
      }
      switch (handleType) {
      case 'left':
        setHandleType('right')
        break
      case 'right':
        // sm md 手动 点击 只能浮层
        if (
          (responsiveType === 'sm' || responsiveType === 'md') &&
            !!isHandel.current
        ) {
          PubSub.publish('OPEN_FIX_NAV', true)
          return
        }
        setHandleType('left')
        break
      case 'bottom':
        setHandleType('top')
        break
      case 'top':
        setHandleType('bottom')
        break
      }
      return
    }
    switch (responsiveType) {
    case 'sm':
    case 'md':
      // sm md 手动 点击 只能浮层
      if (isHandel.current) {
        PubSub.publish('OPEN_FIX_NAV', true)
        return
      }
      setHandleType('left')
      break
    case 'lg':
    case 'xl':
    case '2xl':
      setHandleType('right')
      break
    }
  }, [responsiveType, handleType])

  useEffect(() => {
    if (handleType) {
      // 控制左侧菜单切换
      switch (handleType) {
      case 'left':
        if (isHandel.current) {
          sendTeaCommEvent('clk_event', {
            event_id: 'common_menu_btn',
            shrink_type: 'unfold',
          })
        }
        PubSub.publish('SIDE_NAV_STATUS', 'on')
        break
      case 'right':
        if (isHandel.current) {
          sendTeaCommEvent('clk_event', {
            event_id: 'common_menu_btn',
            shrink_type: 'fold',
          })
        }
        PubSub.publish('SIDE_NAV_STATUS', 'off')
        break
      }
      return
    }
  }, [handleType, responsiveType])

  useEffect(() => {
    switch (responsiveType) {
    case 'sm':
    case 'md':
      setHandleType('right')
      break
    case 'lg':
    case 'xl':
    case '2xl':
      setHandleType('left')
      break
    }
  }, [responsiveType])

  return (
    <p
      className={`side-nav-switch tw-mr-24 lg:tw-mr-40 fl ${
        isFixType ? 'bottom' : `${responsiveType} ${handleType}`
      }`}
      onClick={() => {
        isHandel.current = true
        handleClick()
      }}
    >
      <span className="arrow" />
      <style jsx>
        {`
          .side-nav-switch {
            position: relative;
            width: 24px;
            height: 24px;
            margin-top: 10px;
            background: red;
            cursor: pointer;
            background: url(${require('static/icon-switch-btn.png')}) no-repeat
              0 0 / cover;
          }
          .arrow {
            width: 0;
            height: 0;
            position: absolute;
            right: 2px;
            bottom: 3px;
            border-right: 3px solid transparent;
            border-left: 3px solid transparent;
            border-bottom: 4px solid #1f2129;
            transform: rotate(270deg);
            transition: transform 0.2s ease-in-out;
          }
          .sm .arrow {
            transform: rotate(90deg);
          }
          .md .arrow {
            transform: rotate(90deg);
          }

          .right .arrow {
            transform: rotate(90deg) !important;
          }
          .bottom .arrow {
            transform: rotate(180deg) !important;
          }
          .left .arrow {
            transform: rotate(270deg) !important;
          }
          .top .arrow {
            transform: rotate(0) !important;
          }
        `}
      </style>
    </p>
  )
}

export default HeaderSwitch
